module.exports = __webpack_public_path__ + "img/H000160_bluewhale.86e99a5e.png";